// src/components/page/home/GroupScheduleView.jsx
import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import ScheduleTableDisplay from './ScheduleTableDisplay';

const GroupScheduleView = ({
  filteredArr,
  groupDataReady,
  lastStableGroupSchedulesRef,
  selectedGroup,
  viewMode,
  ViewModes,
  teacherViewScope,
  TeacherViewScopes,
  groupModes,
  selectedDate,
}) => {
  const [displayedSchedules, setDisplayedSchedules] = useState([]);
  const prevGroupRef = useRef(selectedGroup);

  useEffect(() => {
    const isGroupChanged = prevGroupRef.current !== selectedGroup;
    prevGroupRef.current = selectedGroup;

    // Якщо група змінилась — не довіряємо filteredArr одразу
    if (isGroupChanged) {
      if (filteredArr.length > 0) {
        setDisplayedSchedules(filteredArr);
        lastStableGroupSchedulesRef.current = filteredArr;
      } else {
        // Чекаємо на нові дані, але тримаємо старий кеш
        setDisplayedSchedules(lastStableGroupSchedulesRef.current);
      }
    } else {
      // Якщо група та сама — беремо нові дані нормально
      if (filteredArr.length > 0) {
        setDisplayedSchedules(filteredArr);
        lastStableGroupSchedulesRef.current = filteredArr;
      }
    }
  }, [filteredArr, selectedGroup]);

  if (!selectedGroup) {
    return (
      <motion.div className="text-center py-12">
        <AlertTriangle className="mx-auto h-16 w-16 text-accent mb-4" />
        <p className="text-xl font-semibold text-muted-foreground">Оберіть групу для перегляду розкладу</p>
      </motion.div>
    );
  }

// ❗ НЕ показуємо заглушку, якщо є кеш або ми ще чекаємо бекенд
if (groupDataReady && filteredArr.length === 0 && lastStableGroupSchedulesRef.current.length === 0) {
  return (
    <motion.div className="text-center py-12">
      <AlertTriangle className="mx-auto h-16 w-16 text-accent mb-4" />
      <p className="text-xl font-semibold text-muted-foreground">Немає занять, обери іншу дату</p>
    </motion.div>
  );
}


  return (
    <ScheduleTableDisplay
      schedules={displayedSchedules.length ? displayedSchedules : lastStableGroupSchedulesRef.current}
      {...{ viewMode, ViewModes, teacherViewScope, TeacherViewScopes, groupModes, selectedDate }}
    />
  );
};

export default GroupScheduleView;
